export const meetingTypes = {
  vaccination: 'VACCINATION',
  consultation: 'CONSULTATION',
  checkup: 'CHECK_UP',
  imagery: 'IMAGERY',
  labtest: 'LAB_TEST',
  screeningTest: 'SCREENING_TEST',
  socialCare: 'SOCIAL_CARE',
  surgery: 'SURGERY',
  urgency: 'URGENCY',
  lifestyleCoaching: 'LIFESTYLE_COACHING',
};

export const fitnessTypes = {
  fitness: 'FITNESS',
  meditation: 'MEDITATION',
  personalDevelopment: 'PERSONAL_DEVELOPMENT',
  yoga: 'YOGA',
};

export const locationTypes = {
  clinic: 'MEDICAL_CLINIC',
  online: 'ONLINE',
};

export const meetingTypesData = {
  [meetingTypes.vaccination]: {
    label: 'Vaccination',
    value: meetingTypes.vaccination,
  },
  [meetingTypes.consultation]: {
    label: 'Consultation',
    value: meetingTypes.consultation,
  },
  [meetingTypes.checkup]: {
    label: 'Check up',
    value: meetingTypes.checkup,
  },
  [meetingTypes.imagery]: {
    label: 'Imagery',
    value: meetingTypes.imagery,
  },
  [meetingTypes.labtest]: {
    label: 'Lab test',
    value: meetingTypes.labtest,
  },
  [meetingTypes.screeningTest]: {
    label: 'Screening test',
    value: meetingTypes.screeningTest,
  },
  [meetingTypes.socialCare]: {
    label: 'Social care',
    value: meetingTypes.socialCare,
  },
  [meetingTypes.surgery]: {
    label: 'Surgery',
    value: meetingTypes.surgery,
  },
  [meetingTypes.urgency]: {
    label: 'Urgency',
    value: meetingTypes.urgency,
  },
  [meetingTypes.lifestyleCoaching]: {
    label: 'Lifestyle coaching',
    value: meetingTypes.lifestyleCoaching,
  },
};

export const coachTypesData = {
  [fitnessTypes.fitness]: {
    label: 'Fitness',
    value: fitnessTypes.fitness,
  },
  [fitnessTypes.meditation]: {
    label: 'Meditation',
    value: fitnessTypes.meditation,
  },
  [fitnessTypes.yoga]: {
    label: 'Yoga',
    value: fitnessTypes.yoga,
  },
  [fitnessTypes.personalDevelopment]: {
    label: 'Personal Development',
    value: fitnessTypes.personalDevelopment,
  },
};
export const locationTypesData = {
  [locationTypes.clinic]: {
    label: 'Medical clinic',
    value: locationTypes.clinic,
  },
  [locationTypes.online]: {
    label: 'Online',
    value: locationTypes.online,
  },
};
